<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">
          THÊM MỚI THÀNH VIÊN TRONG GIA PHẢ
        </h3>
        <h3 v-if="mData.viewMode === 'detail'">
          CHI TIẾT THÀNH VIÊN TRONG GIA PHẢ
        </h3>
        <h3 v-if="mData.viewMode === 'update'">
          CẬP NHẬT THÀNH VIÊN TRONG GIA PHẢ
        </h3>
      </div>

      <div class="card-body">
        <el-form :model="mData.dataForm" label-position="top" ref="myForm">
          <el-form-item>
            <b-row>
              <b-col md="4" class="upload">
                <div class="image-zone">
                  <div
                    class="image-btn"
                    v-show="!avatar_show"
                    :class="{ deactiveBtn: mData.viewMode == 'detail' }"
                  >
                    <label for="uploadImage">
                      <i class="fas fa-plus-square"></i>
                      Chọn avatar</label
                    >
                    <input
                      type="file"
                      id="uploadImage"
                      style="display: none"
                      accept="image/*"
                      @change="fn_uploadImage"
                      @click="fn_onInputClick"
                      :disabled="mData.viewMode == 'detail'"
                    />
                  </div>
                  <div class="image-show">
                    <img
                      width="100%"
                      :src="avatar_url"
                      v-show="avatar_show"
                      alt="ảnh avatar"
                    />
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      style="display: none"
                      @click="fn_remove()"
                      v-if="mData.viewMode !== 'detail'"
                    ></el-button>
                  </div>
                </div>
              </b-col>
              <b-col md="8">
                <div>
                  <b-row>
                    <b-col>
                      <el-form-item label="Họ tên">
                        <el-input
                          v-model="mData.dataForm.ten.ho_ten"
                          placeholder="Chưa có thông tin"
                          clearable
                          :disabled="mData.viewMode == 'detail'"
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col>
                      <el-form-item label="Thường gọi">
                        <el-input
                          v-model="mData.dataForm.ten.thuong_goi"
                          placeholder="Chưa có thông tin"
                          clearable
                          :disabled="mData.viewMode == 'detail'"
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col>
                      <el-form-item label="Biệt hiệu">
                        <el-input
                          v-model="mData.dataForm.ten.biet_hieu"
                          placeholder="Chưa có thông tin"
                          clearable
                          :disabled="mData.viewMode == 'detail'"
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </div>
                <div>
                  <b-row>
                    <b-col>
                      <el-form-item label="Hiệu">
                        <el-input
                          v-model="mData.dataForm.ten.hieu"
                          placeholder="Chưa có thông tin"
                          clearable
                          :disabled="mData.viewMode == 'detail'"
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col>
                      <el-form-item label="Húy">
                        <el-input
                          v-model="mData.dataForm.ten.huy"
                          placeholder="Chưa có thông tin"
                          clearable
                          :disabled="mData.viewMode == 'detail'"
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col>
                      <el-form-item label="Tự">
                        <el-input
                          v-model="mData.dataForm.ten.tu"
                          placeholder="Chưa có thông tin"
                          clearable
                          :disabled="mData.viewMode == 'detail'"
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col>
                      <el-form-item label="Thụy">
                        <el-input
                          v-model="mData.dataForm.ten.thuy"
                          placeholder="Chưa có thông tin"
                          clearable
                          :disabled="mData.viewMode == 'detail'"
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <el-form-item label="Giới tính">
                        <el-radio
                          v-model="radio"
                          label="nam"
                          style="margin-right: 25px"
                          :disabled="mData.viewMode == 'detail'"
                          >Nam</el-radio
                        >
                        <el-radio
                          v-model="radio"
                          label="nu"
                          :disabled="mData.viewMode == 'detail'"
                          >Nữ</el-radio
                        >
                      </el-form-item>
                    </b-col>
                    <b-col>
                      <el-form-item label="" style="margin-top: 35px">
                        <el-checkbox v-model="checked" disabled
                          >Trong họ</el-checkbox
                        >
                      </el-form-item>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </el-form-item>

          <!-- MỐI QUAN HỆ -->
          <b-row v-show="mData.viewMode !== 'creat'">
            <b-col md="6">
              <el-form-item label="Cha mẹ 1">
                <el-input
                  v-model="cha_me_1_ten"
                  placeholder="Chưa có thông tin"
                  clearable
                  disabled
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Cha mẹ 2">
                <el-input
                  v-model="cha_me_2_ten"
                  placeholder="Chưa có thông tin"
                  clearable
                  disabled
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <el-collapse>
                <el-collapse-item>
                  <template slot="title">
                    <i class="fas fa-user-friends"></i> DANH SÁCH VỢ CHỒNG
                  </template>

                  <div
                    v-for="item in vo_chong_ten"
                    :key="item.index"
                    class="d-flex align-items-center"
                    style="margin-bottom: 10px"
                  >
                    <el-input
                      v-model="item.ten"
                      placeholder="Chưa có thông tin"
                      clearable
                      disabled
                      @input="forceUpdateUI"
                    ></el-input>
                    <el-select
                      v-model="item.li_di"
                      style="width: 260px; margin-left: 10px"
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <el-option
                        v-for="item in trangThaiHonNhan"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      v-model="item.da_mat"
                      style="width: 260px; margin-left: 10px"
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <el-option
                        v-for="item in trangThaiCuocSong"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    v-if="vo_chong_ten.length == 0"
                    style="text-align: center"
                  >
                    <span>Chưa có thông tin tên vợ/chồng</span>
                  </div>
                  <!-- <div style="text-align: center">
                    <el-button
                      icon="el-icon-circle-plus-outline"
                      :disabled="mData.viewMode == 'detail'"
                      >Thêm tên vợ/chồng</el-button>
                   
                  </div> -->
                </el-collapse-item>
              </el-collapse>
            </b-col>
            <b-col md="6">
              <el-collapse>
                <el-collapse-item>
                  <template slot="title">
                    <i class="fas fa-child"></i> DANH SÁCH CON
                  </template>
                  <div
                    v-for="item in con_ten"
                    :key="item.index"
                    class="d-flex align-items-center"
                    style="margin-bottom: 10px"
                  >
                    <el-input
                      v-model="item.ten"
                      placeholder="Chưa có thông tin"
                      clearable
                      disabled
                      @input="forceUpdateUI"
                    ></el-input>
                    <el-select
                      v-model="item.con_nuoi"
                      style="width: 190px; margin-left: 10px"
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <el-option
                        v-for="item in trangThaiCon"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div v-if="con_ten.length == 0" style="text-align: center">
                    <span>Chưa có thông tin tên con</span>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </b-col>
          </b-row>

          <br />

          <b-row>
            <!-- NĂM SINH -->
            <b-col md="6">
              <el-form-item label="Ngày sinh">
                <div class="">
                  <el-select
                    v-model="sinhAmDuong"
                    class="amDuongSelect"
                    @change="changeAmDuongSinh"
                  >
                    <el-option
                      v-for="item in amDuong"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <div class="dateInputDuong" v-show="sinhAmDuong == 'Dương'">
                    <el-input-number
                      v-model="mData.dataForm.sinh.ngay_duong"
                      :min="1"
                      :max="31"
                      placeholder="Ngày"
                      class="dateInput__value"
                    ></el-input-number>
                    <el-input-number
                      v-model="mData.dataForm.sinh.thang_duong"
                      :min="1"
                      :max="12"
                      placeholder="Tháng"
                      class="dateInput__value"
                    ></el-input-number>
                    <el-input-number
                      v-model="mData.dataForm.sinh.nam_duong"
                      :min="0"
                      :max="2100"
                      placeholder="Năm"
                      class="dateInput__value"
                    ></el-input-number>
                  </div>
                  <div class="dateInputAm" v-show="sinhAmDuong == 'Âm'">
                    <el-input-number
                      v-model="mData.dataForm.sinh.ngay_am"
                      :min="1"
                      :max="31"
                      placeholder="Ngày âm"
                      class="dateInput__value"
                    ></el-input-number>
                    <el-input-number
                      v-model="mData.dataForm.sinh.thang_am"
                      :min="1"
                      :max="12"
                      placeholder="Tháng"
                      class="dateInput__value"
                    ></el-input-number>
                    <el-input-number
                      v-model="mData.dataForm.sinh.nam_am"
                      :min="0"
                      :max="2100"
                      placeholder="Năm"
                      class="dateInput__value"
                    ></el-input-number>
                  </div>
                </div>
              </el-form-item>
              <div>
                <b-row>
                  <b-col md="6">
                    <el-switch
                      style="
                        display: block;
                        margin: 10px 0px;
                        width: fit-content;
                      "
                      v-model="isDaMat"
                      active-color="#ff4949"
                      inactive-color="#13ce66"
                      active-text="Đã mất"
                      inactive-text="Còn sống"
                    >
                    </el-switch>
                  </b-col>
                  <!-- <b-col md="6" class="text-right">
                    <el-checkbox
                      v-model="isNamNhuan"
                      disabled
                      @change="fn_changeNamNhuanSinh"
                      >Năm nhuận</el-checkbox
                    >
                  </b-col> -->
                </b-row>
              </div>

              <el-form-item label="Ngày mất" v-if="isDaMat == true">
                <div class="">
                  <el-select
                    v-model="matAmDuong"
                    class="amDuongSelect"
                    @change="changeAmDuongMat"
                  >
                    <el-option
                      v-for="item in amDuong"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <div class="dateInputDuong" v-show="matAmDuong == 'Dương'">
                    <el-input-number
                      v-model="mData.dataForm.mat.ngay_duong"
                      :min="1"
                      :max="31"
                      placeholder="Ngày"
                      class="dateInput__value"
                    ></el-input-number>
                    <el-input-number
                      v-model="mData.dataForm.mat.thang_duong"
                      :min="1"
                      :max="12"
                      placeholder="Tháng"
                      class="dateInput__value"
                    ></el-input-number>
                    <el-input-number
                      v-model="mData.dataForm.mat.nam_duong"
                      :min="0"
                      :max="new Date().getFullYear()"
                      placeholder="Năm"
                      class="dateInput__value"
                    ></el-input-number>
                  </div>
                  <div class="dateInputAm" v-show="matAmDuong == 'Âm'">
                    <el-input-number
                      v-model="mData.dataForm.mat.ngay_am"
                      :min="1"
                      :max="31"
                      placeholder="Ngày"
                      class="dateInput__value"
                    ></el-input-number>
                    <el-input-number
                      v-model="mData.dataForm.mat.thang_am"
                      :min="1"
                      :max="12"
                      placeholder="Tháng"
                      class="dateInput__value"
                    ></el-input-number>
                    <el-input-number
                      v-model="mData.dataForm.mat.nam_am"
                      :min="0"
                      :max="new Date().getFullYear()"
                      placeholder="Năm"
                      class="dateInput__value"
                    ></el-input-number>
                  </div>
                </div>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Kỷ sự">
                <el-input
                  type="textarea"
                  :rows="7"
                  placeholder="Chưa có thông tin"
                  v-model="mData.dataForm.ky_su"
                  :disabled="mData.viewMode == 'detail'"
                  @input="forceUpdateUI"
                >
                </el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_add()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormNodeGiaPha";
import VietnameseDate from "vietnamese-date";

export default {
  components: {
    Circle4,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      avatar_show: false,
      avatar_url: "",
      loading: false,
      checked: "",
      radio: "",
      cha_me_1_ten: "",
      cha_me_2_ten: "",
      con_ten: [],
      vo_chong_ten: [],
      namSinhDuong: "",
      namMatDuong: "",
      namSinhAm: "",
      namMatAm: "",
      isNamNhuan: false,
      isDaMat: false, // ngược 1 tý
      checkNgayMatHonNgaySinh: false,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        ngay: MethodService.copyObject(DataForm.ngay),
        thang: MethodService.copyObject(DataForm.thang),
      },
      trangThaiHonNhan: [
        {
          value: "false",
          label: "Hôn nhân",
        },
        {
          value: "true",
          label: "Ly hôn",
        },
      ],
      trangThaiCuocSong: [
        {
          value: "false",
          label: "Còn sống",
        },
        {
          value: "true",
          label: "Đã mất",
        },
      ],
      trangThaiCon: [
        {
          value: "false",
          label: "Con ruột",
        },
        {
          value: "true",
          label: "Con nuôi",
        },
      ],
      amDuong: [
        { value: "duong", label: "Dương" },
        { value: "am", label: "Âm" },
      ],
      sinhAmDuong: "Dương",
      matAmDuong: "Dương",
      ngaySinh: undefined, // ghép dữ liệu từ ngày, tháng, năm
      ngayMat: undefined, // ghép dữ liệu từ ngày, tháng, năm
      ngaySinhResult: "",
      ngayMatResult: "",
    };
  },
  methods: {
    async fn_initForm() {
      let dataFilter = {
        fields:
          "id,duoc_duyet,gui_yeu_cau,nguoi_dung_id,trong_ho,kich_hoat,dong_ho_id,quan_he,ten,avatar_id,gioi_tinh,sinh,mat,ky_su,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
        filters: [
          "dong_ho_id=" + localStorage.getItem("dong_ho_id"),
          "nguoi_dung_id=" + this.$router.currentRoute.params.nguoi_dung_id,
        ],
      };
      try {
        const response = await mushroom.node_gia_pha.listAsync(dataFilter);
        this.mData.dataForm = response.result[0];
        // check có thông tin ngày âm cho mục Ngày sinh, ngày mất thì hiện Âm
        if (response.result[0].sinh) {
          if (
            !response.result[0].sinh.ngay_duong &&
            !response.result[0].sinh.thang_duong &&
            !response.result[0].sinh.nam_duong &&
            (response.result[0].sinh.ngay_am ||
              response.result[0].sinh.thang_am ||
              response.result[0].sinh.nam_am)
          ) {
            this.sinhAmDuong = "Âm";
          }
        }
        if (response.result[0].mat) {
          if (
            !response.result[0].mat.ngay_duong &&
            !response.result[0].mat.thang_duong &&
            !response.result[0].mat.nam_duong &&
            (response.result[0].mat.ngay_am ||
              response.result[0].mat.thang_am ||
              response.result[0].mat.nam_am)
          ) {
            this.matAmDuong = "Âm";
          }
        }
        if (!response.result[0].hasOwnProperty("sinh")) {
          let sinhData = {
            ngay_duong: null,
            thang_duong: null,
            nam_duong: null,
            ngay_am: null,
            thang_am: null,
            nam_am: null,
          };
          this.mData.dataForm.sinh = Object.assign({}, sinhData);
        }

        this.isDaMat = false;
        if (response.result[0].mat && response.result[0].mat.da_mat) {
          this.isDaMat = response.result[0].mat.da_mat;
        }
        this.checked = response.result[0].trong_ho;
        this.radio = response.result[0].gioi_tinh;

        console.log("Thông tin nốt:", response, this.isDaMat);
        // hiển thị ảnh avatar
        if (response.result[0].avatar_id) {
          this.avatar_show = true;
          this.avatar_url = mushroom.$file.linkBuilder.thumb
            .id(response.result[0].avatar_id)
            .build();
        }

        // hiển thị tên cha mẹ
        if (response.result[0].quan_he) {
          if (response.result[0].quan_he.cha_me_1_id) {
            let cha_me_1_ten = await this.fn_getTen(
              response.result[0].quan_he.cha_me_1_id
            );
            this.cha_me_1_ten = cha_me_1_ten;
          }
        }

        if (response.result[0].quan_he) {
          if (response.result[0].quan_he.cha_me_2_id) {
            let cha_me_2_ten = await this.fn_getTen(
              response.result[0].quan_he.cha_me_2_id
            );
            this.cha_me_2_ten = cha_me_2_ten;
          }
        }

        // hiển thị tên vợ chồng
        this.vo_chong_ten = [];
        if (response.result[0].quan_he) {
          if (response.result[0].quan_he.danh_sach_vo_chong) {
            response.result[0].quan_he.danh_sach_vo_chong.forEach(
              async (item) => {
                this.vo_chong_ten.push({
                  ten: await this.fn_getTen(item.node_id),
                  li_di: item.li_di ? "Ly hôn" : "Hôn nhân",
                  da_mat: item.da_mat ? "Đã mất" : "Còn sống",
                });
              }
            );
          }
        }

        // hiển thị tên con
        this.con_ten = [];
        if (response.result[0].quan_he) {
          if (response.result[0].quan_he.danh_sach_con)
            response.result[0].quan_he.danh_sach_con.forEach(async (item) => {
              this.con_ten.push({
                ten: await this.fn_getTen(item.node_id),
                con_nuoi:
                  item.con_nuoi || item.con_nuoi == true
                    ? "Con nuôi"
                    : "Con ruột",
              });
            });
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Gặp sự cố tải dữ liệu");
        } else window.toastr.error("Đã có lỗi xảy ra");
        this.loading = false;
      }
    },

    async fn_getTen(id) {
      if (id) {
        try {
          const response = await mushroom.node_gia_pha.listAsync({
            fields:
              "id,duoc_duyet,gui_yeu_cau,nguoi_dung_id,kich_hoat,dong_ho_id,quan_he,ten,avatar_id,gioi_tinh,sinh,mat,ky_su,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
            filters: [
              "dong_ho_id=" + localStorage.getItem("dong_ho_id"),
              "id=" + id,
            ],
          });
          return response.result[0].ten.ho_ten;
        } catch (e) {
          console.error("Có lỗi: %o", e);
        }
      } else return;
    },

    // tải lên ảnh đại diện
    async fn_uploadImage() {
      try {
        let res = await mushroom.$file.uploadAsync({
          file: document.getElementById("uploadImage").files[0], // required
        });
        this.$forceUpdate();
        this.mData.dataForm.avatar_id = res.result;
        this.avatar_show = true;
        this.avatar_url = mushroom.$file.linkBuilder.thumb
          .id(res.result)
          .build();

        console.log("id ảnh: ", this.mData.dataForm.avatar_id);
      } catch (error) {
        console.log(error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Gặp sự cố tải dữ liệu");
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
    },

    // xóa ảnh vừa upload
    fn_remove() {
      this.avatar_show = false;
      this.avatar_url = "";
      this.mData.dataForm.avatar_id = null;
      // this.mData.dataForm.anh_btn_show = false;
      this.$forceUpdate();
    },

    // reset lại thẻ input khi vừa xóa ảnh
    fn_onInputClick(event) {
      event.target.value = "";
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },
    // fn_changeNamNhuanSinh(event) {
    //   this.thangNhuanSinh = event;
    // },

    // cập nhật nốt gia phả
    async fn_update() {
      const node_gia_pha_object = {
        id: this.mData.dataForm.id, //node_gia_pha_id
        avatar_id: this.mData.dataForm.avatar_id,
        ten: {
          ho_ten: this.mData.dataForm.ten.ho_ten,
          thuong_goi: this.mData.dataForm.ten.thuong_goi,
          biet_hieu: this.mData.dataForm.ten.biet_hieu,
          hieu: this.mData.dataForm.ten.hieu,
          huy: this.mData.dataForm.ten.huy,
          tu: this.mData.dataForm.ten.tu,
          thuy: this.mData.dataForm.ten.thuy,
        },
        gioi_tinh: this.radio,
        trong_ho: this.checked,
        ky_su: this.mData.dataForm.ky_su,
      };

      if (
        !this.mData.dataForm.sinh.ngay_duong ||
        !this.mData.dataForm.sinh.thang_duong ||
        !this.mData.dataForm.sinh.nam_duong ||
        !this.mData.dataForm.sinh.ngay_am ||
        !this.mData.dataForm.sinh.thang_am ||
        !this.mData.dataForm.sinh.nam_am
      ) {
        this.fn_updateNotEnoughDataSinh(node_gia_pha_object);
        console.log(
          "node_gia_pha_object fn_updateNotEnoughDataSinh",
          node_gia_pha_object
        );
      }
      if (this.isDaMat) {
        if (
          !this.mData.dataForm.mat.ngay_duong ||
          !this.mData.dataForm.mat.thang_duong ||
          !this.mData.dataForm.mat.nam_duong ||
          !this.mData.dataForm.mat.ngay_am ||
          !this.mData.dataForm.mat.thang_am ||
          !this.mData.dataForm.mat.nam_am
        ) {
          this.fn_updateNotEnoughDataMat(node_gia_pha_object);
          console.log(
            "node_gia_pha_object fn_updateNotEnoughDataMat",
            node_gia_pha_object
          );
        }
      }

      if (
        this.mData.dataForm.sinh.ngay_duong &&
        this.mData.dataForm.sinh.thang_duong &&
        this.mData.dataForm.sinh.nam_duong
      ) {
        console.log("đổi ngày sinh dương sang âm");
        this.fn_changeSinhDuongToAm(node_gia_pha_object);
        console.log("node_gia_pha_object", node_gia_pha_object);
      }
      if (
        this.mData.dataForm.sinh.ngay_am &&
        this.mData.dataForm.sinh.thang_am &&
        this.mData.dataForm.sinh.nam_am
      ) {
        this.fn_changeSinhAmToDuong(node_gia_pha_object);
        console.log("node_gia_pha_object", node_gia_pha_object);
      }
      if (this.mData.dataForm.mat) {
        if (
          this.mData.dataForm.mat.ngay_duong &&
          this.mData.dataForm.mat.thang_duong &&
          this.mData.dataForm.mat.nam_duong
        ) {
          this.fn_changeMatDuongToAm(node_gia_pha_object);
          console.log("node_gia_pha_object", node_gia_pha_object);
        }
        if (
          this.mData.dataForm.mat.ngay_am &&
          this.mData.dataForm.mat.thang_am &&
          this.mData.dataForm.mat.nam_am
        ) {
          this.fn_changeMatAmToDuong(node_gia_pha_object);
          console.log("node_gia_pha_object", node_gia_pha_object);
        }
      }

      await this.fn_updateApiNodeGiaPha(node_gia_pha_object);
    },

    async fn_updateApiNodeGiaPha(objData) {
      try {
        const response = await mushroom.node_gia_pha.partialUpdateAsync(
          objData
        );
        if (response.result == this.mData.dataForm.id) {
          window.toastr.success("Cập nhật thành viên thành công");
          MethodService.stopLadda();
          this.$router.go(-1);
        } else {
          window.toastr.warning("Dữ liệu không thay đổi");
          MethodService.stopLadda();
        }
      } catch (e) {
        MethodService.stopLadda();
        console.error("Có lỗi: %o", e);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else {
          window.toastr.error("Đã có lỗi xảy ra");
        }
      }
    },

    // thay đổi lựa chọn ngày dương, âm
    changeAmDuongSinh(event) {
      if (event == "duong") {
        this.sinhAmDuong = "Dương";
      } else {
        this.sinhAmDuong = "Âm";
      }
    },
    changeAmDuongMat(event) {
      if (event == "duong") {
        this.matAmDuong = "Dương";
      } else {
        this.matAmDuong = "Âm";
      }
    },

    // tự động đổi ngày âm, dương cho dữ liệu sinh, mất
    fn_changeSinhDuongToAm(data) {
      if (this.sinhAmDuong == "Dương") {
        const ngaySinh = new Date(
          this.mData.dataForm.sinh.nam_duong,
          this.mData.dataForm.sinh.thang_duong - 1,
          this.mData.dataForm.sinh.ngay_duong
        );
        const ngayAm = new VietnameseDate(ngaySinh);
        const sinhDuongData = {
          ngay_sinh: MethodService.formatDate(ngaySinh, ""),
          ngay_duong: this.mData.dataForm.sinh.ngay_duong,
          thang_duong: this.mData.dataForm.sinh.thang_duong,
          nam_duong: this.mData.dataForm.sinh.nam_duong,
          ngay_am: ngayAm.day,
          thang_am: ngayAm.month,
          nam_am: ngayAm.year,
        };
        data.sinh = Object.assign({}, sinhDuongData);
      }
    },
    fn_changeSinhAmToDuong(data) {
      if (this.sinhAmDuong == "Âm") {
        console.log("chạy chuyển ngày âm sang dương");

        const ngayAm = new VietnameseDate(
          this.mData.dataForm.sinh.nam_am,
          this.mData.dataForm.sinh.thang_am,
          this.mData.dataForm.sinh.ngay_am
        );
        const ngayDuong = ngayAm.solarDate;
        const sinhAmData = {
          ngay_sinh: ngayDuong,
          ngay_duong: new Date(ngayDuong).getDate(),
          thang_duong: new Date(ngayDuong).getMonth() + 1,
          nam_duong: new Date(ngayDuong).getFullYear(),
          ngay_am: this.mData.dataForm.sinh.ngay_am,
          thang_am: this.mData.dataForm.sinh.thang_am,
          nam_am: this.mData.dataForm.sinh.nam_am,
        };
        data.sinh = Object.assign({}, sinhAmData);
      }
    },

    fn_changeMatDuongToAm(data) {
      if (this.matAmDuong == "Dương") {
        const ngayMat = new Date(
          this.mData.dataForm.mat.nam_duong,
          this.mData.dataForm.mat.thang_duong - 1,
          this.mData.dataForm.mat.ngay_duong
        );
        const ngayAm = new VietnameseDate(ngayMat);
        const matDuongData = {
          ngay_mat: ngayMat,
          ngay_duong: this.mData.dataForm.mat.ngay_duong,
          thang_duong: this.mData.dataForm.mat.thang_duong,
          nam_duong: this.mData.dataForm.mat.nam_duong,
          ngay_am: ngayAm.day,
          thang_am: ngayAm.month,
          nam_am: ngayAm.year,
        };
        data.mat = Object.assign({}, matDuongData);
      }
    },
    fn_changeMatAmToDuong(data) {
      if (this.matAmDuong == "Âm") {
        const ngayAm = new VietnameseDate(
          data.mat.nam_am,
          data.mat.thang_am,
          data.mat.ngay_am
        );
        const ngayDuong = ngayAm.solarDate;
        const matAmData = {
          ngay_mat: ngayDuong,
          ngay_duong: new Date(ngayDuong).getDate(),
          thang_duong: new Date(ngayDuong).getMonth() + 1,
          nam_duong: new Date(ngayDuong).getFullYear(),
          ngay_am: this.mData.dataForm.mat.ngay_am,
          thang_am: this.mData.dataForm.mat.thang_am,
          nam_am: this.mData.dataForm.mat.nam_am,
        };
        data.mat = Object.assign({}, matAmData);
      }
    },

    fn_updateNotEnoughDataSinh(data) {
      if (this.sinhAmDuong == "Dương") {
        const sinhData = {
          ngay_sinh: null,
          ngay_duong: this.mData.dataForm.sinh.ngay_duong
            ? this.mData.dataForm.sinh.ngay_duong
            : null,
          thang_duong: this.mData.dataForm.sinh.thang_duong
            ? this.mData.dataForm.sinh.thang_duong
            : null,
          nam_duong: this.mData.dataForm.sinh.nam_duong
            ? this.mData.dataForm.sinh.nam_duong
            : null,
          ngay_am: null,
          thang_am: null,
          nam_am: null,
        };
        data.sinh = Object.assign({}, sinhData);
      }
      if (this.sinhAmDuong == "Âm") {
        const sinhData = {
          ngay_sinh: null,
          ngay_am: this.mData.dataForm.sinh.ngay_am
            ? this.mData.dataForm.sinh.ngay_am
            : null,
          thang_am: this.mData.dataForm.sinh.thang_am
            ? this.mData.dataForm.sinh.thang_am
            : null,
          nam_am: this.mData.dataForm.sinh.nam_am
            ? this.mData.dataForm.sinh.nam_am
            : null,
          ngay_duong: null,
          thang_duong: null,
          nam_duong: null,
        };
        data.sinh = Object.assign({}, sinhData);
      }
    },
    fn_updateNotEnoughDataMat(data) {
      if (this.matAmDuong == "Dương") {
        const matData = {
          da_mat: true,
          ngay_mat: null,
          ngay_duong: this.mData.dataForm.mat.ngay_duong
            ? this.mData.dataForm.mat.ngay_duong
            : null,
          thang_duong: this.mData.dataForm.mat.thang_duong
            ? this.mData.dataForm.mat.thang_duong
            : null,
          nam_duong: this.mData.dataForm.mat.nam_duong
            ? this.mData.dataForm.mat.nam_duong
            : null,
          ngay_am: null,
          thang_am: null,
          nam_am: null,
        };
        data.mat = Object.assign({}, matData);
      }
      if (this.matAmDuong == "Âm") {
        const matData = {
          da_mat: true,
          ngay_mat: null,
          ngay_am: this.mData.dataForm.mat.ngay_am
            ? this.mData.dataForm.mat.ngay_am
            : null,
          thang_am: this.mData.dataForm.mat.thang_am
            ? this.mData.dataForm.mat.thang_am
            : null,
          nam_am: this.mData.dataForm.mat.nam_am
            ? this.mData.dataForm.mat.nam_am
            : null,
          ngay_duong: null,
          thang_duong: null,
          nam_duong: null,
        };
        data.mat = Object.assign({}, matData);
      }
    },

    // kiểm tra năm mất có sau năm sinh hay không
    fn_checkNam(data) {
      if (
        data.sinh.nam_duong > data.mat.nam_duong ||
        data.sinh.nam_am > data.mat.nam_am
      ) {
        window.toastr.warning("Ngày mất phải lớn hơn hoặc bằng ngày sinh");
        MethodService.stopLadda();
        this.checkNgayMatHonNgaySinh = false;
      } else if (
        (data.sinh.nam_duong == data.mat.nam_duong &&
          data.sinh.thang_duong > data.mat.thang_duong) ||
        (data.sinh.nam_am == data.mat.nam_am &&
          data.sinh.thang_am > data.mat.thang_am)
      ) {
        window.toastr.warning("Ngày mất phải lớn hơn hoặc bằng ngày sinh");
        MethodService.stopLadda();
        console.log("chay vao day kkkkkkkkkkkkk");
        this.checkNgayMatHonNgaySinh = false;
      } else if (
        (data.sinh.nam_duong == data.mat.nam_duong &&
          data.sinh.thang_duong == data.mat.thang_duong &&
          data.sinh.ngay_duong > data.mat.ngay_duong) ||
        (data.sinh.nam_am == data.mat.nam_am &&
          data.sinh.thang_am == data.mat.thang_am &&
          data.sinh.ngay_am > data.mat.ngay_am)
      ) {
        window.toastr.warning("Ngày mất phải lớn hơn hoặc bằng ngày sinh");
        MethodService.stopLadda();
        this.checkNgayMatHonNgaySinh = false;
      } else if (
        (data.mat.nam_duong == new Date().getFullYear() &&
          data.mat.thang_duong > new Date().getMonth() + 1) ||
        (data.mat.nam_am == new Date().getFullYear() &&
          data.mat.thang_am > new Date().getMonth() + 1)
      ) {
        window.toastr.warning("Ngày mất không được lớn hơn ngày hiện tại");
        MethodService.stopLadda();
        this.checkNgayMatHonNgaySinh = false;
      }

      console.log("this.checkNgayMatHonNgaySinh", this.checkNgayMatHonNgaySinh);
    },

    fn_changeDateInfo(event, data) {
      if (event == "sinh") {
        if (
          !this.mData.dataForm.sinh.ngay_am ||
          !this.mData.dataForm.sinh.thang_am ||
          !this.mData.dataForm.sinh.nam_am
        ) {
          data.sinh.ngay_duong = undefined;
          data.sinh.thang_duong = undefined;
          data.sinh.nam_duong = undefined;
          data.sinh.ngay_am = this.mData.dataForm.sinh.ngay_am;
          data.sinh.thang_am = this.mData.dataForm.sinh.thang_am;
          data.sinh.nam_am = this.mData.dataForm.sinh.nam_am;
        } else if (
          !this.mData.dataForm.sinh.ngay_duong ||
          !this.mData.dataForm.sinh.thang_duong ||
          !this.mData.dataForm.sinh.nam_duong
        ) {
          data.sinh.ngay_am = undefined;
          data.sinh.thang_am = undefined;
          data.sinh.nam_am = undefined;
          data.sinh.ngay_duong = this.mData.dataForm.sinh.ngay_duong;
          data.sinh.thang_duong = this.mData.dataForm.sinh.thang_duong;
          data.sinh.nam_duong = this.mData.dataForm.sinh.nam_duong;
        }
        console.log("data", data);
      }

      if (event == "mat") {
        if (
          !this.mData.dataForm.mat.ngay_am ||
          !this.mData.dataForm.mat.thang_am ||
          !this.mData.dataForm.mat.nam_am
        ) {
          data.mat.ngay_duong = undefined;
          data.mat.thang_duong = undefined;
          data.mat.nam_duong = undefined;
        }

        if (
          !this.mData.dataForm.mat.ngay_duong ||
          !this.mData.dataForm.mat.thang_duong ||
          !this.mData.dataForm.mat.nam_duong
        ) {
          data.mat.ngay_am = undefined;
          data.mat.thang_am = undefined;
          data.mat.nam_am = undefined;
        }
      }
      return data;
    },

    // nút điều hướng
    fn_cancel() {
      this.fn_resetForm();
      this.$router.go(-1);
    },
    fn_back() {
      this.$router.go(-1);
    },
  },
  async created() {
    // kiểm tra loại viewMode
    if (this.$router.currentRoute.name == "ThemNodeGiaPha") {
      this.mData.viewMode = "create";
    }
    if (this.$router.currentRoute.name == "ChiTietNodeGiaPha") {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.name == "CapNhatNodeGiaPha") {
      this.mData.viewMode = "update";
    }
    await this.fn_initForm();
  },
};
</script>
<style scoped lang="scss">
.image-zone {
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: 0.3s;
  width: 203px;
  height: 203px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}
.image-zone:hover {
  border-color: #409eff;
}

.image-show {
  position: relative;
  button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  img {
    width: 178px;
    height: 178px;
    object-fit: cover;
    border-radius: 5px;
  }
  img,
  .el-button--danger {
    transition: 0.3s;
  }
  &:hover img {
    opacity: 0.8;
  }
  &:hover .el-button--danger {
    display: block !important;
  }
}
.image-btn {
  padding: 0px 5px;
  border: 1px solid #b3d8ff;
  border-radius: 3px;
  width: fit-content;

  color: #3b5dbf;
  background-color: #ecf5ff;
  transition: 0.3s;
  font-size: 13px;
  &:hover {
    background-color: #409eff;
    color: #fff;
  }
  label {
    cursor: pointer;
    padding: 3px !important;
    margin: 0;
  }
  i {
    margin-right: 5px;
  }
}
.deactiveBtn {
  border: 1px solid #d3d4d6;
  background-color: #f4f4f5;
  color: rgb(109, 109, 109);
  &:hover {
    background-color: #f4f4f5;
    color: rgb(109, 109, 109);
  }
  label,
  i {
    cursor: no-drop;
  }
}
.quan-he {
  padding: 5px 10px;
  background-color: #3a7bd5;
  // background: #00d2ff; /* fallback for old browsers */
  // background: -webkit-linear-gradient(
  //   to right,
  //   #3a7bd5,
  //   #00d2ff
  // ); /* Chrome 10-25, Safari 5.1-6 */
  // background: linear-gradient(
  //   to right,
  //   #3a7bd5,
  //   #00d2ff
  // ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  width: fit-content;
  border-radius: 15px;
  color: #fff;
  margin: 15px 0 10px 0px;
}
.group-vc {
  display: flex;
}
.btn-ly-hon,
.btn-da-mat {
  padding: 3px 5px;
  border-radius: 5px;
  width: 80px;
  text-align: center;
  margin-left: 10px;
  color: #fff;
  font-weight: 600;
  font-size: 12px;
}
.btn-ly-hon {
  background-color: #f56c6c;
}
.btn-da-mat {
  background-color: #929292;
}
::v-deep.amDuongSelect {
  width: 100px;
  input {
    border: none;
    background-color: #e6a23c;
    color: #fff;
  }
  .el-select__caret {
    color: #fff;
  }
}
::v-deep span.el-input-number__decrease,
::v-deep span.el-input-number__increase {
  display: none;
}
::v-deep.dateInputDuong,
::v-deep.dateInputAm {
  display: flex;
  width: calc(100% - 110px);
  float: right;
}
::v-deep .dateInput__value {
  margin: 0 5px;
  .el-input__inner {
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
